import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from 'lib/auth';

import { Header } from '../components/Landing/Header';
import { Hero } from '../components/Landing/Hero';
import { TrustedBy } from '../components/Landing/TrustedBy';
import { Integrations } from '../components/Landing/Integrations';
import { DeveloperSection } from '../components/Landing/DeveloperSection';
import { CTA } from '../components/Landing/CTA';
import { Footer } from '../components/Landing/Footer';
import { PricingPreview } from '../components/Landing/PricingPreview';

export const Landing = () => {
  const navigate = useNavigate();
  const { user } = useAuth();

  const handleStart = () => {
    if (user) navigate('/app');
    else navigate('/auth/login');
  };

  return (
    <div className="min-h-screen bg-slate-950 text-white flex flex-col">
      {/* Header */}
      <Header user={user} onStart={() => navigate(`/start-building?plan=Starter`)} />

      {/* Hero */}
      <Hero user={user} onStart={() => navigate(`/start-building?plan=Starter`)} />

      <main className="relative z-10">
        {/* Social proof */}
        <TrustedBy />

        {/* Platform overview */}
        {/* <section id="platform">
          <PlatformOverview />
        </section> */}

        {/* Feature marketplace */}
        {/* <section id="features">
          <FeatureMarketplace />
        </section> */}

        {/* Integrations */}
        <section id="integrations">
          <Integrations />
        </section>

        {/* Developers */}
        <section id="developers">
          <DeveloperSection />
        </section>

        {/* CTA */}
        <CTA onStart={handleStart} />

        <section id="pricing">
          <PricingPreview />
        </section>
      </main>

      <Footer className="mt-16" />
    </div>
  );
};

export default Landing;
